import { Box, Flex, Text } from '@radix-ui/themes'
import Logo from '../assets/images/mango-logo.png'
import RegisterForm from '../components/forms/RegisterForm'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const Register = () => {
  const user = useSelector(state => state.user);
  const account = useSelector(state => state.account);
  const authToken = localStorage.getItem('authToken')
  const [registerRole, setRegisterRole] = useState('student');

  // useEffect(() => {
  //   const isAuthenticated = user?.details && account?.details && authToken;
  //   if (isAuthenticated) {
  //     window.location.href = '/';
  //   }
  // }, [])

  return (
    <Flex direction="column" gap="4" align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Box style={{ width: '100%', maxWidth: '400px' }}>
        <Flex direction={"column"} align="center" justify="center">
          <img src="/edusua.svg" style={{ display:'block', maxWidth: '200px', marginBottom: '40px' }} />
          <Text size="6" mb="4">Create a new <Text color='blue'>{registerRole}</Text> account</Text>
        </Flex>

        <RegisterForm setRegisterRole={setRegisterRole} />
      </Box>
    </Flex>
  )
}

export default Register

